"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACProgress = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ACTypography_1 = require("./ACTypography");
var DEFAULT_COLOR = '#5C67C9';
var ACProgress = function (props) {
    var value = props.value, name = props.name, _a = props.height, height = _a === void 0 ? '10px' : _a, _b = props.color, color = _b === void 0 ? DEFAULT_COLOR : _b, _c = props.showLabel, showLabel = _c === void 0 ? true : _c, _d = props.duration, duration = _d === void 0 ? 500 : _d, label = props.label, containerClassName = props.containerClassName;
    var _e = (0, react_1.useState)(0), progress = _e[0], setProgress = _e[1];
    (0, react_1.useEffect)(function () {
        var animationFrame;
        var start = performance.now();
        var animate = function (time) {
            var elapsed = time - start;
            var progressPercent = Math.min((elapsed / duration) * value, value);
            setProgress(progressPercent);
            if (elapsed < duration) {
                animationFrame = requestAnimationFrame(animate);
            }
        };
        animationFrame = requestAnimationFrame(animate);
        return function () { return cancelAnimationFrame(animationFrame); };
    }, [value, duration]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: containerClassName, children: [(0, jsx_runtime_1.jsx)(ACTypography_1.ACTypography, { name: name, element: "typography", type: "p", label: label }), (0, jsx_runtime_1.jsxs)("div", { style: {
                    width: '100%',
                    backgroundColor: '#e5e5e5',
                    borderRadius: '8px',
                    height: height,
                }, children: [(0, jsx_runtime_1.jsx)("div", { style: {
                            width: "".concat(progress, "%"),
                            height: '100%',
                            backgroundColor: color || DEFAULT_COLOR,
                            transition: "width ".concat(duration, "ms ease-in-out"),
                            borderRadius: '8px',
                        } }), showLabel && ((0, jsx_runtime_1.jsxs)("div", { style: {
                            marginTop: '4px',
                            textAlign: 'right',
                            fontSize: '0.8rem',
                            color: '#333',
                        }, children: [Math.round(progress), "%"] }))] })] }));
};
exports.ACProgress = ACProgress;
